/**
 * Nutrition Facts Section
 * Handles progress bars animation, collapsible functionality, and tabs
 */

class NutritionFacts {
  constructor(container) {
    this.container = container || document.querySelector('.w-nutrition-facts');

    if (!this.container) return;

    this.progressBars = this.container.querySelectorAll('.w-nutrition-facts__bar-fill');
    this.collapsibleTriggers = this.container.querySelectorAll('.w-nutrition-facts__collapsible-trigger');
    this.tabButtons = this.container.querySelectorAll('.w-nutrition-facts__tab-button');
    this.tabPanels = this.container.querySelectorAll('.w-nutrition-facts__tab-panel');
    this.observer = null;

    this.init();
  }

  init() {
    this.initProgressBars();
    this.initCollapsible();
    this.initTabs();
  }

  initProgressBars() {
    if (this.progressBars.length === 0) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.progressBars.forEach((bar, index) => {
            const targetWidth = bar.getAttribute('data-width');

            setTimeout(() => {
              bar.style.width = targetWidth + '%';
            }, index * 150);
          });

          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    this.observer.observe(this.container);
  }

  initCollapsible() {
    this.collapsibleTriggers.forEach(trigger => {
      trigger.addEventListener('click', function () {
        const isCollapsed = this.classList.contains('collapsed');
        const content = this.nextElementSibling;

        if (isCollapsed) {
          // Open
          this.classList.remove('collapsed');
          content.classList.remove('collapsed');
          this.setAttribute('aria-expanded', 'true');
        } else {
          // Close
          this.classList.add('collapsed');
          content.classList.add('collapsed');
          this.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  initTabs() {
    if (this.tabButtons.length === 0 || this.tabPanels.length === 0) return;

    console.log('[Nutrition Facts] Tabs initialized:', {
      buttons: this.tabButtons.length,
      panels: this.tabPanels.length
    });

    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const targetTab = button.getAttribute('data-tab');
        console.log('[Nutrition Facts] Tab clicked:', targetTab);

        // Remove active class from all buttons in all panels
        this.tabButtons.forEach(btn => btn.classList.remove('active'));

        // Add active class to all buttons with the same data-tab (one in each panel)
        const matchingButtons = this.container.querySelectorAll(`[data-tab="${targetTab}"]`);
        matchingButtons.forEach(btn => btn.classList.add('active'));

        // Remove active class from all panels
        this.tabPanels.forEach(panel => panel.classList.remove('active'));

        // Add active class to the corresponding panel
        const targetPanel = this.container.querySelector(`[data-panel="${targetTab}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');

          // Log image info for debugging
          const activeImage = targetPanel.querySelector('[data-nutrition-image]');
          if (activeImage) {
            const productId = activeImage.getAttribute('data-product-id');
            console.log('[Nutrition Facts] Image changed to product:', productId);
          } else {
            console.warn('[Nutrition Facts] No image found in active panel');
          }

          // Re-trigger progress bar animation for the active tab
          const activeBars = targetPanel.querySelectorAll('.w-nutrition-facts__bar-fill');
          activeBars.forEach((bar, index) => {
            bar.style.width = '0';
            const targetWidth = bar.getAttribute('data-width');

            setTimeout(() => {
              bar.style.width = targetWidth + '%';
            }, index * 150);
          });
        } else {
          console.error('[Nutrition Facts] Target panel not found:', targetTab);
        }
      });
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  const nutritionSection = document.querySelector('.w-nutrition-facts');
  if (nutritionSection) {
    new NutritionFacts(nutritionSection);
  }
});

// Expose class globally for dynamic initialization
window.NutritionFacts = NutritionFacts;
